import debug from "@cher-ami/debug"
const log = debug(`front:defaultTransitions`)

const yValue = 100
const defaultduration = 0.75

export const defaultPlayIn = (
	$root?: HTMLElement,
	comeFrom?: string,
	resolve?: () => void
): void => {
	log("dir comeFrom:", comeFrom)
	$root.style.opacity = "0"

	const animation = $root.animate([{ opacity: 0 }, { opacity: 1 }], {
		duration: defaultduration * 0.75 * 1000,
		easing: "ease-out"
	})

	animation.onfinish = () => {
		$root.style.opacity = "1"
		resolve?.()
	}
}

export const defaultPlayOut = (
	$root?: HTMLElement,
	goTo?: string,
	resolve?: () => void
): void => {
	log("dir goTo: ", goTo)
	$root.animate([{ opacity: 1 }, { opacity: 0 }], {
		duration: defaultduration * 1000,
		easing: "ease-out"
	}).onfinish = resolve
}

export const defaultPlayInTranslate = (
	$root?: HTMLElement,
	comeFrom?: string,
	resolve?: () => void,
	direction: "up" | "down" = "up",
	duration: number = defaultduration
): void => {
	const translateYValue = direction === "up" ? -window.innerHeight : window.innerHeight
	$root.style.transform = `translateY(${translateYValue}px)`

	const animation = $root.animate(
		[{ transform: `translateY(${translateYValue}px)` }, { transform: "translateY(0px)" }],
		{
			duration: duration * 1000,
			easing: "ease-out"
		}
	)

	animation.onfinish = () => {
		$root.style.transform = "translateY(0)"
		resolve?.()
	}
}

export const defaultPlayOutTranslate = (
	$root?: HTMLElement,
	goTo?: string,
	resolve?: () => void,
	direction: "up" | "down" = "up",
	duration: number = defaultduration
): void => {
	const translateYValue = direction === "up" ? -window.innerHeight : window.innerHeight
	log("dir goTo: ", goTo)
	const animation = $root.animate(
		[{ transform: "translateY(0px)" }, { transform: `translateY(${translateYValue}px)` }],
		{
			duration: defaultduration * 1000 * 0.5,
			easing: "ease-out"
		}
	)

	animation.onfinish = () => {
		$root.style.transform = `translateY(${translateYValue}%)`
		resolve?.()
	}
}
